module.exports = __webpack_public_path__ + "static/media/SW300.4c2adf5e.pdf";